import { createContext, useContext, type Context } from 'react';

import {
  type ConvertibleUnit,
  type FormatOptions,
  type Unit,
  format,
} from '@dynatrace-sdk/units';

import {
  isFormatterOptions,
  type Formatter,
} from '../../../core/types/formatter.js';

export type FormatterContextProps = {
  /**
   * Custom or default formatter for the chart
   * @defaultValue the default formatter
   */
  formatter: Formatter | FormatOptions<Unit, ConvertibleUnit>;
  unit?: string | Unit;
};

export const FormatterContext: Context<FormatterContextProps> =
  createContext<FormatterContextProps>({} as FormatterContextProps);

export const useFormatter = () => {
  const context = useContext(FormatterContext);

  if (context === undefined) {
    throw new Error('useFormatter must be within FormatterContext');
  }

  const { formatter, unit } = context;

  if (isFormatterOptions(formatter)) {
    return { formatter: (value: number) => format(value, formatter) };
  }

  return { formatter, unit };
};
